var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForklift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4425 6.73369C30.3527 3.64396 26.2431 1.94611 21.8755 1.94611C17.5019 1.94611 13.3982 3.64396 10.3085 6.73369C7.21875 9.82342 5.51489 13.9331 5.51489 18.3007C5.51489 27.1379 13.8722 34.4933 18.3658 38.441C18.9897 38.9929 19.5237 39.4669 19.9556 39.8628C20.4956 40.3668 21.1855 40.6188 21.8755 40.6188C22.5654 40.6188 23.2554 40.3668 23.7893 39.8628C24.2213 39.4669 24.7612 38.9929 25.3852 38.441C29.8728 34.4933 38.2301 27.1379 38.2301 18.3007C38.2301 13.9331 36.5322 9.82342 33.4425 6.73369V6.73369Z",
    fill: "#0E64A9",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7649 23.7541C25.5798 23.7541 25.4036 23.6451 25.3258 23.4642L19.8056 10.6122C19.7016 10.3698 19.8134 10.0888 20.0557 9.98483C20.2984 9.88116 20.5791 9.99268 20.6831 10.2354L26.0153 22.6495L32.0038 20.101C32.2472 19.9971 32.5272 20.1106 32.6305 20.3534C32.7339 20.5964 32.6213 20.8768 32.3781 20.9797L25.9521 23.7147C25.8905 23.7409 25.8268 23.754 25.7649 23.754V23.7541ZM29.4044 14.4451C29.301 14.2023 29.02 14.0895 28.7776 14.1932L24.5438 15.9954C24.3007 16.0991 24.1882 16.3797 24.2911 16.6221L26.2617 21.2522C26.3654 21.4942 26.6456 21.6075 26.8885 21.5045L31.1227 19.702C31.3655 19.5986 31.4788 19.3184 31.3751 19.0753L29.4044 14.4451ZM19.8736 24.617C19.8736 25.9355 20.9426 27.0048 22.2614 27.0048C23.5799 27.0048 24.6489 25.9354 24.6489 24.617C24.6489 23.2981 23.58 22.2294 22.2614 22.2294C20.9426 22.2296 19.8736 23.2981 19.8736 24.617ZM19.2401 25.1744H15.8692C15.8692 23.7848 14.7425 22.658 13.3525 22.658C12.6264 22.658 11.9739 22.9673 11.5149 23.4596V19.5943C11.5149 19.3306 11.7286 19.1165 11.9927 19.1165H12.756V13.7665C12.756 13.4366 13.0232 13.1695 13.353 13.1695H19.6107C19.8496 13.1695 20.0653 13.3118 20.1596 13.5311L23.2523 20.748C23.2908 20.8387 23.3033 20.9324 23.2966 21.0251V21.0266V21.7252C22.9732 21.6091 22.6257 21.5429 22.2623 21.5429C20.5645 21.5429 19.1879 22.919 19.1879 24.6169C19.1871 24.8076 19.2068 24.993 19.2401 25.1743L19.2401 25.1744ZM18.2076 20.5493H21.8679L19.2164 14.3637H13.9491V19.1169H17.5337L18.2076 20.5493ZM11.5219 25.1744C11.5219 26.1854 12.341 27.0049 13.3521 27.0049C14.363 27.0049 15.1823 26.1858 15.1823 25.1744C15.1823 24.1641 14.3632 23.3446 13.3521 23.3446C12.341 23.3445 11.5219 24.1641 11.5219 25.1744Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3508",
    x: 0.0148926,
    y: 0.446106,
    width: 43.7151,
    height: 49.6727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3508",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.f86b5a8a056bec84a5caa4de63207a94.svg";
export { ForwardRef as ReactComponent };